import { Button as B } from "@mantine/core";
import { palette } from "../../../theme";

export const PrimaryButton = (props) => {
  return (
    <B
      variant="primary"
      radius="lg"
      styles={{
        root: {
          fontFamily: "Roboto",
          background: palette.primaryUI[1],
          borderColor: palette.primaryUI[1],
          borderWidth: "0px",
          borderStyle: "solid",
          transition: "all 200ms ease",
          color: palette.primaryUI[0],
          boxShadow: `6px 6px 12px ${palette.primaryUI[2]},
             -6px -6px 12px ${palette.primaryUI[0]}`,
          "&:hover": {
            background: palette.primaryUI[1],
            boxShadow: `6px 6px 12px ${palette.primaryUI[2]},
             -6px -6px 12px ${palette.primaryUI[0]}, inset 0 0 20px 0 rgba(0,0,0,0.25), inset 0 0 0 1px rgba(255,255,255,0.35)`,
          },
          "&:disabled": {
            boxShadow: `6px 6px 12px ${palette.grayUI[2]},
             -6px -6px 12px ${palette.grayUI[0]}`,
          },
          "&:active": {
            color: palette.primaryUI[0],
            boxShadow: `inset 0 0 5px ${palette.primaryUI[3]}, inset 4px 4px 12px #2a5fa4, inset -4px -4px 12px #91c0ff`,
          },
        },
      }}
      size="lg"
      {...props}
    >
      {props.children}
    </B>
  );
};
